import React from "react";
import { Redirect } from "react-router-dom";

/**
 * The Notification detail page was merged into the push compose form, which now fills in both the
 * notification centre and a raw Firebase send. Its URL stays alive so that saved links, the
 * browser history and anything still pointing at `/Notification_Detail?id=…` keep working - the
 * query string is carried across unchanged, which is what makes an edit link resolve.
 *
 * The redux slice next to this file has NOT moved: the compose form dispatches those same actions.
 */
const NotificationDetailRedirect = ({ location }) => (
  <Redirect to={`/PushNoti_Compose${location.search || ""}`} />
);

export default NotificationDetailRedirect;
